var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlogOko = function SvgBlogOko(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 96,
    width: 96,
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 20c21.15 0 34.502 19.998 38.998 28C82.494 56.016 69.145 76 48 76 26.853 76 13.503 56.118 9.003 48.149 13.5 40.101 26.853 20 48 20m0-8C16 12 0 48.166 0 48.166S16 84 48 84s48-36 48-36-16-36-48-36z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 40c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8m0-8c-8.836 0-16 7.164-16 16 0 8.837 7.164 16 16 16 8.837 0 16-7.163 16-16 0-8.836-7.163-16-16-16z"
  })));
};
export default SvgBlogOko;